import { render, staticRenderFns } from "./AddRuleModal.vue?vue&type=template&id=2b709f2a&"
import script from "./AddRuleModal.vue?vue&type=script&lang=js&"
export * from "./AddRuleModal.vue?vue&type=script&lang=js&"
import style0 from "./AddRuleModal.vue?vue&type=style&index=0&id=2b709f2a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports